import { createPortal } from 'react-dom'
import PayoffMetaDataDisplay from './PayoffMetaDataDisplay'
import { memo } from 'react'
import { PAYOFF_LEGEND_LEFT_SCALE_OFFSET_PX } from '../../util/payoffChart'
import { useSelector } from 'react-redux'
import { selectPayoffPreferences } from '../../selectors/user'

export type PayoffMetaDataProps = {
    paneContainer: HTMLElement | undefined
    historicalOptionChain: boolean
}

const PayoffMetaData = ({ paneContainer, historicalOptionChain }: PayoffMetaDataProps) => {
    const { showOiBars = true } = useSelector(selectPayoffPreferences)
    const legendLeft = showOiBars ? 6 + PAYOFF_LEGEND_LEFT_SCALE_OFFSET_PX : 6
    // const { expressionMode, primary, underlying } = useSelector(selectPrimarySecurity)
    // const security = expressionMode ? null : primary && isFnOSecurity(primary) ? underlying : primary
    // const underlyingToken = security ? getSecurityKey(security.exchange, security.code) : ''
    // const securitySnapshot = useSelector(selectSnapshot(underlyingToken))
    // const historicalOptionChainSnapshot = useSelector(selectOptionsChainUnderlyingPrices(underlyingToken))
    // const theme = useTheme()

    return !paneContainer ? null : createPortal(<>
        <div className="pane-meta-container" style={{ left: legendLeft }}>
            <PayoffMetaDataDisplay />
        </div>
        {/* <Box sx={{
            position: 'absolute',
            top: 5,
            textAlign: 'center',
            width: '100%',
            zIndex: 4,
            pointerEvents: 'none',
            fontSize: '12px'
        }}>
            <span style={{
                fontSize: '9px',
                color: theme.palette.text.secondary
            }}>SPOT</span> {((historicalOptionChain ? (historicalOptionChainSnapshot?.underlyingCurrentPrice??0) : securitySnapshot?.lastTradedPrice) / (security?.priceMultiplier ?? 100)).toFixed(log10(security?.priceMultiplier ?? 100))}
        </Box> */}

    </>, paneContainer)
}

export default memo(PayoffMetaData)